import { Card as MUICard, CardProps } from '@mui/material';
import React from 'react';
import { styled } from '@/theme/index';

const StyledCard = styled(MUICard)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: theme.spacing(2),

  '&.hover-shadow': {
    '&:hover': {
      boxShadow:
        '0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)',
    },
  },

  '&.premium': {
    position: 'relative',
    overflow: 'inherit',
  },
}));

export const Card: React.FC<CardProps> = React.forwardRef(
  (props: CardProps, ref) => {
    return (
      <StyledCard {...props} ref={ref}>
        {props.children}
      </StyledCard>
    );
  }
);

export type { CardProps };
